module.exports = __webpack_public_path__ + "static/media/banner_trends_sat.a782380e.jpg";